var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import * as _ from 'lodash';
import { Component, ViewChild } from '@angular/core';
import { FontElementSettingModal } from '../base/font-element-setting-modal';
var HyperlinkModalComponent = /** @class */ (function (_super) {
    __extends(HyperlinkModalComponent, _super);
    function HyperlinkModalComponent(injector) {
        return _super.call(this, injector, 'hyperlinkModal') || this;
    }
    HyperlinkModalComponent.prototype.onShown = function () {
        $(this.textInput.nativeElement).focus();
    };
    HyperlinkModalComponent.prototype.init = function (editedComponent) {
        var _this = this;
        _super.prototype.init.call(this, editedComponent);
        var componentData = editedComponent.model.data;
        this.configureId = editedComponent.configureId;
        this.loadFontInfo(componentData);
        this.loadGraphSetting(componentData);
        this.text = componentData.text;
        this.linkAddress = componentData.linkAddress;
        setTimeout(function () {
            _this.displaySettingCmp.init(editedComponent);
        }, 500);
    };
    HyperlinkModalComponent.prototype.saveText = function () {
        this.saveComponentProperty('text', this.text);
    };
    HyperlinkModalComponent.prototype.saveLinkAddress = function () {
        this.saveComponentProperty('linkAddress', this.linkAddress);
    };
    HyperlinkModalComponent.prototype.save = function () {
        this.saving = true;
        this.currentDiagram.startTransaction('hyperlink settings');
        if (!this.displaySettingCmp.save()) {
            this.saving = false;
            return;
        }
        if (!this.displaySettingCmp.save()) {
            this.saving = false;
            this.setActiveTab(3);
            return;
        }
        this.saveFontInfo();
        this.saveGraphSetting();
        this.saveText();
        this.saveLinkAddress();
        this.currentDiagram.commitTransaction('hyperlink settings');
        this.close();
    };
    HyperlinkModalComponent.prototype.setActiveTab = function (tabId) {
        this.staticTabs.tabs[tabId].active = true;
    };
    HyperlinkModalComponent.prototype.loadGraphSetting = function (componentData) {
        this.useGraph = componentData.useGraph;
        if (null != componentData.graphSetting) {
            this.graphSetting = _.cloneDeep(componentData.graphSetting);
        }
        else {
            this.graphSetting = {};
        }
    };
    HyperlinkModalComponent.prototype.saveGraphSetting = function () {
        this.saveComponentProperty('useGraph', this.useGraph);
        if (this.useGraph) {
            this.saveComponentProperty('graphSetting', this.graphSetting);
        }
        else {
            this.deleteComponentProperty('graphSetting');
        }
        this.deleteComponentProperty('graphUrl');
    };
    __decorate([
        ViewChild('displaySettingCmp', { static: false })
    ], HyperlinkModalComponent.prototype, "displaySettingCmp", void 0);
    __decorate([
        ViewChild('staticTabs', { static: false })
    ], HyperlinkModalComponent.prototype, "staticTabs", void 0);
    __decorate([
        ViewChild('textInput', { static: false })
    ], HyperlinkModalComponent.prototype, "textInput", void 0);
    HyperlinkModalComponent = __decorate([
        Component({
            selector: 'hyperlink-modal',
            styles: [".element-setting-base{ .inline-label { margin: 10px 0px 0px 10px; display: inline-block; } .border-group { // border: 1px solid #ddd; padding: 5px; margin-bottom: 0px; } .inline-selector { display: inline-block; margin: 5px 0px; } .inline-variable { display: inline-block; margin: 5px 0px; } .inline-input { display: inline-block; margin: 5px 0px; }     } .date-time-setting-modal { .modal-content { width: 600px; } .cursor-pointer{ cursor: pointer; } .recode-input{ width: calc(100% - 70px); border: 1px solid #d7dbe5;   padding:  5px 10px; } textarea.noResize { resize: none; } } .toggleViewSettingModal { .modal-content { width: 600px; } } .textSettingModal { .modal-content { width: 600px; } } "],
            template: "<div bsModal #settingModal=\"bs-modal\" id=\"textSettingModal\" class=\"modal fade textSettingModal element-setting-base\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"settingModal\" (onShown)=\"onShown()\" aria-hidden=\"true\" (onHidden)=\"onHidden()\" [config]=\"{backdrop: 'static'}\"> <div class=\"modal-dialog\"> <div class=\"modal-content element-setting-base\"> <div class=\"fe-modal-container\"> <form class=\"configure\" *ngIf=\"active\" #textAttributeForm=\"ngForm\" novalidate (ngSubmit)=\"save()\"> <div class=\"modal-header fe-modal-header\"> <div class=\"fe-modal-header-title\"> {{lc(\"Hyperlink\")}} </div> <div class=\"fe-modal-header-close\" aria-label=\"Close\" (click)=\"close()\">×</div> </div> <div class=\"top-line\"></div> <div class=\"fe-modal-middle valueShow design-nav-link\"> <tabset #staticTabs class=\"tab-container tabbable-line\"> <tab heading=\"{{lc('GeneralProperty')}}\" customClass=\"m-tabs__item\"> <div class=\"fe-modal-content\"> <div class=\"fe-vertical-label\"> <font-style [(fontSize)]=\"fontSize\" [(fontColor)]=\"fontColor\" [(textAlign)]=\"textAlign\" [(isUnderline)]=\"isUnderline\" [(fontStyle)]=\"fontStyle\"></font-style> </div> <div class=\"fe-vertical-label margin-top-20\"> <textarea class=\"whole-width noResize\" rows=\"6\" name=\"text\" #textInput required maxlength=\"500\" [(ngModel)]=\"text\"> </textarea> </div> <div class=\"fe-transverse-label margin-top-10 clearfix\"> <label for=\"\" class=\"fe-transverse-title\">{{lc(\"LinkAddress\")}}</label> <input type=\"text\" name=\"linkAddress\" class=\"fe-transverse-input\" [(ngModel)]=\"linkAddress\"> </div> </div> </tab> <tab heading=\"{{lc('Graph')}}\" customClass=\"m-tabs__item\" (selectTab)=\"tabSelected(graphSettingEventName)\"> <graph-setting [configureId]=\"configureId\" [(useGraph)]=\"useGraph\" [graphSetting]=\"graphSetting\"></graph-setting> </tab> <tab heading=\"{{lc('Display')}}\" customClass=\"m-tabs__item\" (selectTab)=\"tabSelected(controlSettingEventName,configureId)\"> <display-setting #displaySettingCmp [isFixedPositionVisible]='true'></display-setting> </tab> </tabset> </div> <div class=\"fe-modal-footer\"> <div class=\"button-group\"> <button type=\"submit\" class=\"fe-btn fe-btn-default fe-btn-save\" [disabled]=\"!textAttributeForm.form.valid\" [buttonBusy]=\"saving\" [busyText]=\"l('SavingWithThreeDot')\"> {{l(\"Save\")}} </button> <button [disabled]=\"saving\" type=\"button\" class=\"fe-btn fe-btn-default fe-btn-cancel-one\" (click)=\"close()\"> {{l(\"Cancel\")}} </button> </div> </div> </form> </div> </div> </div> </div>"
        })
    ], HyperlinkModalComponent);
    return HyperlinkModalComponent;
}(FontElementSettingModal));
export { HyperlinkModalComponent };
